<template>
    <div class="bg-f9f9f9">
        <Mainlayout></Mainlayout>
        <br /> <br /> <br /> <br />
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
    
    
                <img style="max-width:100%" src="../assets/img/bannergallery.png" />
                <h3 class="custom-48px-600 mt-5 text-left">Gallery</h3>
                <p class="custom-20px-500 color-brown">Explore our gallery dedicated to historic sports tournaments, where the triumphs and legends of yesteryear come to life through captivating photographs, memorabilia, and artwork, offering a nostalgic journey through the iconic moments and enduring legacies of sporting events gone by</p>
            </CCol>
        </CCol>
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
                <h3 class="custom-48px-600 mt-5 text-center">Gallery</h3>
                <CRow>
                    <CCol sm="6">
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <div class="text-right float-right">
                            <CSelect class="mb-0 mx-1" size="sm" value="Medium" :options="['Sort By']" custom/>
                        </div>
                    </CCol>
    
                    <CCol sm="6">
                        <h3 class="custom-20px-600 text-left mt-4">Today</h3>
                    </CCol>
                    <CCol sm="6">
                        <div class="text-right float-right mt-4">
                            <img src="../assets/img/Location2.png" style="max-width:20px" /><label class="custom-18px-400 color-blue"> Subang Jaya </label><label class="color-dark-grey">. September 2024</label>
                        </div>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g1.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                20 Sept 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g2.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                10 June 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g3.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                10 July 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g9.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                20 Nov 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g5.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                20 Feb 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g6.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                10 July 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g7.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                5 Feb 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g8.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                11 Sept 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
                    <CCol sm="4">
                        <CCard class="bg-white b-20" style="border:none">
                            <div style="padding:10px">
                            <img style="max-width:100%;border-radius:10px;" src="../assets/img/g10.jpeg" />
                            <p class="custom-16px-500 mt-2 color-dark-grey" style="padding:0px">
                                20 Jan 2023
                            </p>
                        </div>
                        </CCard>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
        </CCol>
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center custom-card-grey mb-5 mt-5">
                    <h3 class="custom-48px-600 mt-5">Have a question or <br />feedback?</h3>
                    <p class="custom-16px-400 color-171717">Have a question or feedback? Fill out the form below, and our team will be in</p>
                    <br /><br />
                    <span class="custom-blur-radius-bottom-right p-10 mt-5 text-white p-20 mb-5">
                                                       Contact Us <img style="width:20px" src="../assets/img/Calling.png" />
                                                   
                                                    </span>
                    <br /><br /> <br /><br />
    
                </div>
    
            </CCol>
        </CCol>
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

        };
    },
    created() {
        AOS.init();

    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },





    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>